import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  recentClearButtonStyles,
  recentSectionHeaderStyles,
} from '../../../../UniversalSearch.styles';
import CategoryHeader from '../CategoryHeader';
import SearchResultItem from '../SearchResultItem';

const RecentSection = ({ recentItems, onSelect, onClear }) => {
  if (!recentItems?.length) {
    return null;
  }

  return (
    <Box>
      <Box sx={recentSectionHeaderStyles}>
        <CategoryHeader label="Recent" />
        <Typography sx={recentClearButtonStyles} variant="regular12" onClick={onClear}>
          Clear
        </Typography>
      </Box>
      {recentItems.map(item => (
        <SearchResultItem item={item} key={`recent-${item.id}`} onClick={onSelect} />
      ))}
    </Box>
  );
};

RecentSection.propTypes = {
  onClear: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  recentItems: PropTypes.arrayOf(PropTypes.object),
};

export default RecentSection;
